@if (store.isLoadingSignRequest()) {
  <div class="mx-12 flex h-full max-w-[440px] items-center justify-center py-16">
    <ng-lottie [options]="lottieOptions" currentColor class="text-primary-blue" />
  </div>
} @else {
  <div class="mx-12 flex max-w-[440px] flex-col gap-3 bg-background-white shadow-sm">
    <div class="flex flex-col gap-5 rounded-3xl bg-gradient-to-br from-[#f8fcff] to-[#f0f8ff] px-4 py-5">
      <img
        src="assets/images/ffd-notes-sign-up-modal/baa-secure.png"
        alt="HIIPA Compliant & SOC 2 Compliant"
        class="max-w-[326px] self-center"
      />

      <p class="text-center text-primary-blue">
        <span class="typo-h5-semibold">{{ 'baa_signup_info_feature1' | translate }} </span>
        <span class="typo-h5-book">{{ 'baa_signup_info_feature2' | translate }}</span>
      </p>

      <h1 class="typo-h2 whitespace-pre-line text-center text-text-primary">
        {{ isPendingState() ? ('express_app_baa_who_will_sign_title' | translate) : ('express_baa_authorization3_sign_title' | translate) }}
      </h1>

      @if (!isPendingState()) {
        <p
          [innerHTML]="'express_baa_authorization3_sign_message' | translate | markdown | async"
          class="typo-h5-light font-thin text-text-secondary"
        ></p>
      } @else {
        <p
          [innerHTML]="'express_baa_authorization3_sign_pending_message' | translate | markdown | async"
          class="typo-h5-light font-thin text-text-secondary"
        ></p>
      }

      @if (!isPendingState()) {
        <div class="flex flex-col gap-2">
          <button
            type="button"
            class="flex w-full items-center gap-3 rounded-2xl border bg-background-white px-3 py-4 text-left"
            [ngClass]="selection() === 'authorized' ? 'border-primary-blue' : 'border-background-disabled'"
            (click)="onSelect('authorized')"
          >
            <lib-radio-button class="shrink-0" [ngModel]="selection() === 'authorized'" />
            <span class="typo-h4-semibold flex-1 text-text-primary">{{ 'express_baa_authorization3_sign_me' | translate }}</span>
            <svg-icon key="px-24-sign" size="md" class="shrink-0 text-primary-blue" />
          </button>

          <button
            type="button"
            class="flex w-full items-center gap-3 rounded-2xl border bg-background-white px-3 py-4 text-left"
            [ngClass]="selection() === 'not-authorized' ? 'border-primary-blue' : 'border-background-disabled'"
            (click)="onSelect('not-authorized')"
          >
            <lib-radio-button class="shrink-0" [ngModel]="selection() === 'not-authorized'" />
            <span class="typo-h4-semibold flex-1 text-text-primary">{{ 'express_baa_authorization3_sign_request' | translate }}</span>
            <svg-icon key="px-24-send" size="md" class="shrink-0 text-primary-blue" />
          </button>
        </div>

        <button type="button" class="btn-primary mt-3 w-full justify-center" (click)="onNext()" [disabled]="!selection()">
          {{ nextButtonTitle() | translate }}
        </button>
      }
    </div>

    @if (isPendingState()) {
      <div class="flex flex-col gap-4 rounded-3xl bg-background-light-grey px-4 py-5">
        <div class="flex items-center gap-1">
          <svg-icon key="px-24-tick" size="md" class="text-secondary-green" />
          <p class="typo-h3-semibold text-text-primary">{{ 'express_app_baa_pending_sign_request_sent_to' | translate }}</p>
        </div>

        <div class="flex w-full flex-col items-center gap-1 rounded-2xl bg-background-white px-4 py-5 text-center">
          <p class="typo-h3-medium text-text-primary">{{ store.pendingSignerName() }}</p>
          <p class="typo-h4-light text-text-secondary">{{ store.pendingSignerEmail() }}</p>
          <p class="typo-h4-light text-text-secondary">{{ store.pendingInvitationSiteName() }}</p>
        </div>

        <div class="font-poppins text-[14px]/[20px] text-text-tertiary">
          <p class="mb-1">
            {{ 'express_app_baa_sign_request_sent_text1' | translate }}
          </p>
          <p>{{ 'express_app_baa_sign_request_sent_text2' | translate }}</p>
        </div>
      </div>
    }
  </div>
}
